import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "86",
        height: "86",
        viewBox: "0 0 86 86",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M58.4538 71.6667H28.3461L25.9325 74.4492C25.681 74.9527 25.681 75.5457 25.9325 76.051L27.3191 78.8334H59.4721L60.8586 76.051C61.1101 75.5475 61.1101 74.9527 60.8586 74.4492L58.4538 71.6667Z",
                fill: "url(#paint0_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M56.7326 75.2499H30.0674C29.1165 75.2499 28.3462 74.4705 28.3462 73.5084V70.7708H58.4539V73.5084C58.4539 74.4705 57.6836 75.2499 56.7326 75.2499Z",
                fill: "url(#paint1_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M57.5666 71.6667H29.2333C28.5037 71.6667 28.0876 70.8246 28.525 70.2333L32.2437 65.2167C32.5784 64.7652 33.1026 64.5 33.6604 64.5H53.1395C53.6973 64.5 54.2215 64.7652 54.5562 65.2167L58.275 70.2333C58.7123 70.8246 58.2962 71.6667 57.5666 71.6667Z",
                fill: "url(#paint2_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M60.5418 79.4013L59.9946 80.1C59.6599 80.4369 59.2048 80.625 58.732 80.625H28.0399C27.5618 80.625 27.1032 80.4315 26.7667 80.0893L26.2142 79.3744C25.9309 78.9677 25.7432 78.57 25.7432 78.0988V75.25L26.857 76.5364C27.1899 76.8607 27.6362 77.0417 28.1001 77.0417H58.771C59.2544 77.0417 59.7184 76.8446 60.0548 76.497L61.0465 75.25V78.0916C61.0465 78.5664 60.8305 79.0215 60.5418 79.4013Z",
                fill: "url(#paint3_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M33.3382 37.392V38.0908C32.435 38.6103 31.4434 38.5028 30.859 38.8433C30.859 38.7895 30.859 38.7358 30.8413 38.6999C23.6163 37.5837 27.7193 39.1765 20.8467 34.8819C17.5884 32.8931 15.0029 27.8406 14.2238 24.2573C13.7988 22.4835 13.6925 20.6919 13.7811 18.936C13.7988 18.5061 13.8342 18.076 13.8873 17.646C13.9581 17.1802 13.9581 16.8756 14.1175 16.1948C14.4186 15.0123 15.2331 13.9373 16.3665 13.2565C16.9331 12.9161 17.5884 12.6652 18.2613 12.5577C18.8988 12.4323 19.7488 12.486 20.1915 12.5756C20.9352 12.6831 21.6967 12.7906 22.5998 13.0415C22.2811 13.8656 21.7675 15.1377 21.4488 15.926C20.9175 15.8723 20.2977 15.8365 19.6779 15.7648C19.2529 15.729 19.1998 15.7469 18.9519 15.7827C18.7571 15.8365 18.5623 15.8902 18.3852 16.0156C18.0311 16.2306 17.7477 16.571 17.6415 16.9831C17.6061 17.1085 17.5529 17.6281 17.5175 17.9686C17.4644 18.3448 17.4467 18.7211 17.429 19.0973C17.3404 20.6202 17.4431 23.1017 17.7973 24.5171C18.6048 27.8693 20.1915 31.3165 22.83 33.0365C25.4154 34.7744 28.8934 36.3349 32.2402 37.0695L32.4173 37.1053C32.9131 37.2308 33.2673 36.9441 33.3382 37.392Z",
                fill: "url(#paint4_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.1942 37.9259C32.1057 37.392 31.6913 36.9459 31.1353 36.8527C27.7176 36.2758 24.438 34.9696 21.8597 32.8501C19.3061 30.6876 17.6823 27.6364 17.128 24.3271C16.8358 22.677 16.7331 20.9767 16.8323 19.2711C16.8854 18.42 16.9314 17.5654 17.0465 16.7144C17.1103 16.2019 17.3334 15.8024 17.6769 15.5104C18.0205 15.2326 18.4296 15.0965 18.8563 15.1216C19.6939 15.2291 20.6856 15.2774 21.339 15.3903C21.4258 15.3975 21.5037 15.4136 21.5728 15.4297C21.3709 15.9798 20.9548 16.6445 20.574 17.2949L20.551 17.3343C20.3739 17.6353 20.3792 18.0259 20.5935 18.3286C20.8839 18.7371 21.4453 18.8303 21.849 18.5383C22.6388 17.9649 23.3808 17.3934 24.0679 16.3489C24.229 16.0711 24.3955 15.7379 24.4805 15.2631C24.5797 14.8026 24.4805 14.0806 24.121 13.5736C23.3631 12.5881 22.6831 12.4735 22.1536 12.2531C21.0522 11.9234 20.2376 11.7944 19.2884 11.6332C17.9195 11.4146 16.4551 11.8554 15.4174 12.753C14.3584 13.6237 13.6837 14.9585 13.535 16.2611C13.4216 17.225 13.3225 18.1961 13.326 19.1725C13.3136 21.1236 13.5031 23.0945 13.9688 25.0223C14.8897 28.8672 17.0625 32.5258 20.1862 34.9392C23.0054 37.2486 26.3859 38.4956 29.754 39.2894C29.8036 39.6799 29.8213 40.0741 29.7771 40.4701C29.7416 40.8159 29.6549 41.1563 29.5415 41.4877C29.4371 41.8049 29.2423 42.1721 29.113 42.3764L29.028 42.509C28.8084 42.853 28.8474 43.317 29.1449 43.618C29.4866 43.9656 30.0444 43.9674 30.388 43.6198C30.8201 43.1844 31.0715 42.8171 31.3354 42.3656C31.5833 41.9267 31.7923 41.4609 31.9357 40.9699C32.2314 39.9935 32.3058 38.9418 32.1942 37.9259Z",
                fill: "#FEDD30"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.1942 37.9259C32.1057 37.392 31.6913 36.9459 31.1353 36.8527C27.7176 36.2758 24.438 34.9696 21.8597 32.8501C19.3061 30.6876 17.6823 27.6364 17.128 24.3271C16.8358 22.677 16.7331 20.9767 16.8323 19.2711C16.8854 18.42 16.9314 17.5654 17.0465 16.7144C17.1103 16.2019 17.3334 15.8024 17.6769 15.5104C18.0205 15.2326 18.4296 15.0965 18.8563 15.1216C19.6939 15.2291 20.6856 15.2774 21.339 15.3903C21.4258 15.3975 21.5037 15.4136 21.5728 15.4297C21.3709 15.9798 20.9548 16.6445 20.574 17.2949L20.551 17.3343C20.3739 17.6353 20.3792 18.0259 20.5935 18.3286C20.8839 18.7371 21.4453 18.8303 21.849 18.5383C22.6388 17.9649 23.3808 17.3934 24.0679 16.3489C24.229 16.0711 24.3955 15.7379 24.4805 15.2631C24.5797 14.8026 24.4805 14.0806 24.121 13.5736C23.3631 12.5881 22.6831 12.4735 22.1536 12.2531C21.0522 11.9234 20.2376 11.7944 19.2884 11.6332C17.9195 11.4146 16.4551 11.8554 15.4174 12.753C14.3584 13.6237 13.6837 14.9585 13.535 16.2611C13.4216 17.225 13.3225 18.1961 13.326 19.1725C13.3136 21.1236 13.5031 23.0945 13.9688 25.0223C14.8897 28.8672 17.0625 32.5258 20.1862 34.9392C23.0054 37.2486 26.3859 38.4956 29.754 39.2894C29.8036 39.6799 29.8213 40.0741 29.7771 40.4701C29.7416 40.8159 29.6549 41.1563 29.5415 41.4877C29.4371 41.8049 29.2423 42.1721 29.113 42.3764L29.028 42.509C28.8084 42.853 28.8474 43.317 29.1449 43.618C29.4866 43.9656 30.0444 43.9674 30.388 43.6198C30.8201 43.1844 31.0715 42.8171 31.3354 42.3656C31.5833 41.9267 31.7923 41.4609 31.9357 40.9699C32.2314 39.9935 32.3058 38.9418 32.1942 37.9259Z",
                fill: "url(#paint5_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M32.1942 37.9259C32.1057 37.392 31.6913 36.9459 31.1353 36.8527C27.7176 36.2758 24.438 34.9696 21.8597 32.8501C19.3061 30.6876 17.6823 27.6364 17.128 24.3271C16.8358 22.677 16.7331 20.9767 16.8323 19.2711C16.8854 18.42 16.9314 17.5654 17.0465 16.7144C17.1103 16.2019 17.3334 15.8024 17.6769 15.5104C18.0205 15.2326 18.4296 15.0965 18.8563 15.1216C19.6939 15.2291 20.6856 15.2774 21.339 15.3903C21.4258 15.3975 21.5037 15.4136 21.5728 15.4297C21.3709 15.9798 20.9548 16.6445 20.574 17.2949L20.551 17.3343C20.3739 17.6353 20.3792 18.0259 20.5935 18.3286C20.8839 18.7371 21.4453 18.8303 21.849 18.5383C22.6388 17.9649 23.3808 17.3934 24.0679 16.3489C24.229 16.0711 24.3955 15.7379 24.4805 15.2631C24.5797 14.8026 24.4805 14.0806 24.121 13.5736C23.3631 12.5881 22.6831 12.4735 22.1536 12.2531C21.0522 11.9234 20.2376 11.7944 19.2884 11.6332C17.9195 11.4146 16.4551 11.8554 15.4174 12.753C14.3584 13.6237 13.6837 14.9585 13.535 16.2611C13.4216 17.225 13.3225 18.1961 13.326 19.1725C13.3136 21.1236 13.5031 23.0945 13.9688 25.0223C14.8897 28.8672 17.0625 32.5258 20.1862 34.9392C23.0054 37.2486 26.3859 38.4956 29.754 39.2894C29.8036 39.6799 29.8213 40.0741 29.7771 40.4701C29.7416 40.8159 29.6549 41.1563 29.5415 41.4877C29.4371 41.8049 29.2423 42.1721 29.113 42.3764L29.028 42.509C28.8084 42.853 28.8474 43.317 29.1449 43.618C29.4866 43.9656 30.0444 43.9674 30.388 43.6198C30.8201 43.1844 31.0715 42.8171 31.3354 42.3656C31.5833 41.9267 31.7923 41.4609 31.9357 40.9699C32.2314 39.9935 32.3058 38.9418 32.1942 37.9259Z",
                fill: "url(#paint6_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.4",
                d: "M32.1942 37.9259C32.1057 37.392 31.6913 36.9459 31.1353 36.8527C27.7176 36.2758 24.438 34.9696 21.8597 32.8501C19.3061 30.6876 17.6823 27.6364 17.128 24.3271C16.8358 22.677 16.7331 20.9767 16.8323 19.2711C16.8854 18.42 16.9314 17.5654 17.0465 16.7144C17.1103 16.2019 17.3334 15.8024 17.6769 15.5104C18.0205 15.2326 18.4296 15.0965 18.8563 15.1216C19.6939 15.2291 20.6856 15.2774 21.339 15.3903C21.4258 15.3975 21.5037 15.4136 21.5728 15.4297C21.3709 15.9798 20.9548 16.6445 20.574 17.2949L20.551 17.3343C20.3739 17.6353 20.3792 18.0259 20.5935 18.3286C20.8839 18.7371 21.4453 18.8303 21.849 18.5383C22.6388 17.9649 23.3808 17.3934 24.0679 16.3489C24.229 16.0711 24.3955 15.7379 24.4805 15.2631C24.5797 14.8026 24.4805 14.0806 24.121 13.5736C23.3631 12.5881 22.6831 12.4735 22.1536 12.2531C21.0522 11.9234 20.2376 11.7944 19.2884 11.6332C17.9195 11.4146 16.4551 11.8554 15.4174 12.753C14.3584 13.6237 13.6837 14.9585 13.535 16.2611C13.4216 17.225 13.3225 18.1961 13.326 19.1725C13.3136 21.1236 13.5031 23.0945 13.9688 25.0223C14.8897 28.8672 17.0625 32.5258 20.1862 34.9392C23.0054 37.2486 26.3859 38.4956 29.754 39.2894C29.8036 39.6799 29.8213 40.0741 29.7771 40.4701C29.7416 40.8159 29.6549 41.1563 29.5415 41.4877C29.4371 41.8049 29.2423 42.1721 29.113 42.3764L29.028 42.509C28.8084 42.853 28.8474 43.317 29.1449 43.618C29.4866 43.9656 30.0444 43.9674 30.388 43.6198C30.8201 43.1844 31.0715 42.8171 31.3354 42.3656C31.5833 41.9267 31.7923 41.4609 31.9357 40.9699C32.2314 39.9935 32.3058 38.9418 32.1942 37.9259Z",
                fill: "url(#paint7_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M53.4619 37.392V38.0908C54.365 38.6103 55.3567 38.5028 55.9411 38.8433C55.9411 38.7895 55.9411 38.7358 55.9588 38.6999C63.1838 37.5837 59.0808 39.1765 65.9534 34.8819C69.2117 32.8931 71.7971 27.8406 72.5763 24.2573C73.0013 22.4835 73.1075 20.6919 73.019 18.936C73.0013 18.5061 72.9659 18.076 72.9127 17.646C72.8419 17.1802 72.8419 16.8756 72.6825 16.1948C72.3815 15.0123 71.5669 13.9373 70.4336 13.2565C69.8669 12.9161 69.2117 12.6652 68.5388 12.5577C67.9013 12.4323 67.0513 12.486 66.6086 12.5756C65.8648 12.6831 65.1034 12.7906 64.2002 13.0415C64.519 13.8656 65.0325 15.1377 65.3513 15.926C65.8825 15.8723 66.5023 15.8365 67.1221 15.7648C67.5471 15.729 67.6002 15.7469 67.8482 15.7827C68.043 15.8365 68.2377 15.8902 68.4148 16.0156C68.769 16.2306 69.0523 16.571 69.1586 16.9831C69.194 17.1085 69.2471 17.6281 69.2825 17.9686C69.3357 18.3448 69.3534 18.7211 69.3711 19.0973C69.4596 20.6202 69.1674 24.01 68.8133 25.4255C68.1049 28.2384 66.6086 31.3165 63.97 33.0365C61.3846 34.7744 57.9067 36.3349 54.5598 37.0695L54.3827 37.1053C53.8869 37.2308 53.5327 36.9441 53.4619 37.392Z",
                fill: "url(#paint8_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M54.8662 40.9719C55.0096 41.4628 55.2186 41.9286 55.4665 42.3676C55.7304 42.8191 55.9818 43.1864 56.4139 43.6218C56.7574 43.9676 57.3135 43.9676 57.657 43.62C57.9545 43.319 57.9935 42.8549 57.7739 42.5109L57.6889 42.3784C57.5579 42.1741 57.3648 41.8068 57.2604 41.4897C57.1453 41.1582 57.0585 40.8178 57.0248 40.472C56.9788 40.0761 56.9983 39.6819 57.0479 39.2913C60.4178 38.4976 63.7965 37.2506 66.6157 34.9411C69.7394 32.526 71.9122 28.8692 72.8331 25.0243C73.297 23.0982 73.4883 21.1256 73.4759 19.1745C73.4777 18.198 73.3803 17.2269 73.2669 16.263C73.1182 14.9587 72.4435 13.6257 71.3863 12.7549C70.3468 11.8573 68.8841 11.4166 67.5153 11.6351C66.5661 11.7964 65.7515 11.9254 64.65 12.2551C64.1206 12.4754 63.4406 12.5901 62.6827 13.5755C62.3214 14.0826 62.2222 14.8064 62.3232 15.2651C62.4082 15.7399 62.5746 16.0731 62.7358 16.3508C63.4229 17.3971 64.1648 17.9669 64.9546 18.5402C65.3584 18.8341 65.9197 18.7391 66.2102 18.3306C66.4244 18.0278 66.4297 17.6372 66.2527 17.3362L66.2261 17.295C65.8454 16.6464 65.4292 15.9799 65.2256 15.4299C65.2946 15.4138 65.3743 15.3976 65.4593 15.3905C66.1128 15.2776 67.1044 15.2292 67.942 15.1217C68.3688 15.0966 68.7779 15.2328 69.1232 15.5123C69.4667 15.8061 69.6898 16.2039 69.7536 16.7163C69.8669 17.5656 69.913 18.422 69.9679 19.273C70.0653 20.9769 69.9643 22.679 69.6721 24.3291C69.1179 27.6401 67.4922 30.6913 64.9405 32.8521C62.3621 34.9716 59.0808 36.2777 55.6648 36.8546C55.1088 36.9478 54.6944 37.3939 54.6059 37.9261C54.4943 38.9419 54.5687 39.9936 54.8662 40.9719Z",
                fill: "#FEDD30"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M54.8662 40.9719C55.0096 41.4628 55.2186 41.9286 55.4665 42.3676C55.7304 42.8191 55.9818 43.1864 56.4139 43.6218C56.7574 43.9676 57.3135 43.9676 57.657 43.62C57.9545 43.319 57.9935 42.8549 57.7739 42.5109L57.6889 42.3784C57.5579 42.1741 57.3648 41.8068 57.2604 41.4897C57.1453 41.1582 57.0585 40.8178 57.0248 40.472C56.9788 40.0761 56.9983 39.6819 57.0479 39.2913C60.4178 38.4976 63.7965 37.2506 66.6157 34.9411C69.7394 32.526 71.9122 28.8692 72.8331 25.0243C73.297 23.0982 73.4883 21.1256 73.4759 19.1745C73.4777 18.198 73.3803 17.2269 73.2669 16.263C73.1182 14.9587 72.4435 13.6257 71.3863 12.7549C70.3468 11.8573 68.8841 11.4166 67.5153 11.6351C66.5661 11.7964 65.7515 11.9254 64.65 12.2551C64.1206 12.4754 63.4406 12.5901 62.6827 13.5755C62.3214 14.0826 62.2222 14.8064 62.3232 15.2651C62.4082 15.7399 62.5746 16.0731 62.7358 16.3508C63.4229 17.3971 64.1648 17.9669 64.9546 18.5402C65.3584 18.8341 65.9197 18.7391 66.2102 18.3306C66.4244 18.0278 66.4297 17.6372 66.2527 17.3362L66.2261 17.295C65.8454 16.6464 65.4292 15.9799 65.2256 15.4299C65.2946 15.4138 65.3743 15.3976 65.4593 15.3905C66.1128 15.2776 67.1044 15.2292 67.942 15.1217C68.3688 15.0966 68.7779 15.2328 69.1232 15.5123C69.4667 15.8061 69.6898 16.2039 69.7536 16.7163C69.8669 17.5656 69.913 18.422 69.9679 19.273C70.0653 20.9769 69.9643 22.679 69.6721 24.3291C69.1179 27.6401 67.4922 30.6913 64.9405 32.8521C62.3621 34.9716 59.0808 36.2777 55.6648 36.8546C55.1088 36.9478 54.6944 37.3939 54.6059 37.9261C54.4943 38.9419 54.5687 39.9936 54.8662 40.9719Z",
                fill: "url(#paint9_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M54.8662 40.9719C55.0096 41.4628 55.2186 41.9286 55.4665 42.3676C55.7304 42.8191 55.9818 43.1864 56.4139 43.6218C56.7574 43.9676 57.3135 43.9676 57.657 43.62C57.9545 43.319 57.9935 42.8549 57.7739 42.5109L57.6889 42.3784C57.5579 42.1741 57.3648 41.8068 57.2604 41.4897C57.1453 41.1582 57.0585 40.8178 57.0248 40.472C56.9788 40.0761 56.9983 39.6819 57.0479 39.2913C60.4178 38.4976 63.7965 37.2506 66.6157 34.9411C69.7394 32.526 71.9122 28.8692 72.8331 25.0243C73.297 23.0982 73.4883 21.1256 73.4759 19.1745C73.4777 18.198 73.3803 17.2269 73.2669 16.263C73.1182 14.9587 72.4435 13.6257 71.3863 12.7549C70.3468 11.8573 68.8841 11.4166 67.5153 11.6351C66.5661 11.7964 65.7515 11.9254 64.65 12.2551C64.1206 12.4754 63.4406 12.5901 62.6827 13.5755C62.3214 14.0826 62.2222 14.8064 62.3232 15.2651C62.4082 15.7399 62.5746 16.0731 62.7358 16.3508C63.4229 17.3971 64.1648 17.9669 64.9546 18.5402C65.3584 18.8341 65.9197 18.7391 66.2102 18.3306C66.4244 18.0278 66.4297 17.6372 66.2527 17.3362L66.2261 17.295C65.8454 16.6464 65.4292 15.9799 65.2256 15.4299C65.2946 15.4138 65.3743 15.3976 65.4593 15.3905C66.1128 15.2776 67.1044 15.2292 67.942 15.1217C68.3688 15.0966 68.7779 15.2328 69.1232 15.5123C69.4667 15.8061 69.6898 16.2039 69.7536 16.7163C69.8669 17.5656 69.913 18.422 69.9679 19.273C70.0653 20.9769 69.9643 22.679 69.6721 24.3291C69.1179 27.6401 67.4922 30.6913 64.9405 32.8521C62.3621 34.9716 59.0808 36.2777 55.6648 36.8546C55.1088 36.9478 54.6944 37.3939 54.6059 37.9261C54.4943 38.9419 54.5687 39.9936 54.8662 40.9719Z",
                fill: "url(#paint10_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.4",
                d: "M54.8662 40.9719C55.0096 41.4628 55.2186 41.9286 55.4665 42.3676C55.7304 42.8191 55.9818 43.1864 56.4139 43.6218C56.7574 43.9676 57.3135 43.9676 57.657 43.62C57.9545 43.319 57.9935 42.8549 57.7739 42.5109L57.6889 42.3784C57.5579 42.1741 57.3648 41.8068 57.2604 41.4897C57.1453 41.1582 57.0585 40.8178 57.0248 40.472C56.9788 40.0761 56.9983 39.6819 57.0479 39.2913C60.4178 38.4976 63.7965 37.2506 66.6157 34.9411C69.7394 32.526 71.9122 28.8692 72.8331 25.0243C73.297 23.0982 73.4883 21.1256 73.4759 19.1745C73.4777 18.198 73.3803 17.2269 73.2669 16.263C73.1182 14.9587 72.4435 13.6257 71.3863 12.7549C70.3468 11.8573 68.8841 11.4166 67.5153 11.6351C66.5661 11.7964 65.7515 11.9254 64.65 12.2551C64.1206 12.4754 63.4406 12.5901 62.6827 13.5755C62.3214 14.0826 62.2222 14.8064 62.3232 15.2651C62.4082 15.7399 62.5746 16.0731 62.7358 16.3508C63.4229 17.3971 64.1648 17.9669 64.9546 18.5402C65.3584 18.8341 65.9197 18.7391 66.2102 18.3306C66.4244 18.0278 66.4297 17.6372 66.2527 17.3362L66.2261 17.295C65.8454 16.6464 65.4292 15.9799 65.2256 15.4299C65.2946 15.4138 65.3743 15.3976 65.4593 15.3905C66.1128 15.2776 67.1044 15.2292 67.942 15.1217C68.3688 15.0966 68.7779 15.2328 69.1232 15.5123C69.4667 15.8061 69.6898 16.2039 69.7536 16.7163C69.8669 17.5656 69.913 18.422 69.9679 19.273C70.0653 20.9769 69.9643 22.679 69.6721 24.3291C69.1179 27.6401 67.4922 30.6913 64.9405 32.8521C62.3621 34.9716 59.0808 36.2777 55.6648 36.8546C55.1088 36.9478 54.6944 37.3939 54.6059 37.9261C54.4943 38.9419 54.5687 39.9936 54.8662 40.9719Z",
                fill: "url(#paint11_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.9417 50.1667H39.8584V62.7084H46.9417V50.1667Z",
                fill: "url(#paint12_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M46.9417 60.9166H39.8583L39.8548 60.913C38.7834 59.288 38.7834 53.5887 39.8548 51.9636L39.8583 51.9583H46.9417L46.9452 51.9618C48.0166 53.5869 48.0166 59.2862 46.9452 60.9112L46.9417 60.9166Z",
                fill: "url(#paint13_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M48.7124 63.4519H43.3999H38.0874C38.0874 63.4519 33.717 65.6807 32.7749 67.5692C32.7749 67.5692 32.7749 68.6262 32.7749 68.8269C32.7749 70.6186 41.6291 70.6186 43.3999 70.6186C45.1707 70.6186 54.0249 70.6186 54.0249 68.8269C54.0249 68.628 54.0249 67.5692 54.0249 67.5692C53.0952 65.6807 48.7124 63.4519 48.7124 63.4519Z",
                fill: "url(#paint14_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M54.0249 67.5637C54.0249 68.7999 48.8718 69.1045 45.6489 69.1762C44.6395 69.1941 43.8249 69.1941 43.3999 69.1941C42.3728 69.1941 38.9374 69.1941 36.2457 68.8716C34.3155 68.6387 32.7749 68.2445 32.7749 67.5637C32.7749 65.9512 38.1937 62.7083 38.1937 62.7083H48.6062C48.6062 62.7083 54.0249 65.9512 54.0249 67.5637Z",
                fill: "url(#paint15_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M54.0249 67.5637C54.0249 68.7999 48.8718 69.1045 45.6489 69.1762C44.6395 69.1941 43.8249 69.1941 43.3999 69.1941C42.3728 69.1941 38.9374 69.1941 36.2457 68.8716C34.3155 68.6387 32.7749 68.2445 32.7749 67.5637C32.7749 65.9512 38.1937 62.7083 38.1937 62.7083H48.6062C48.6062 62.7083 54.0249 65.9512 54.0249 67.5637Z",
                fill: "url(#paint16_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M39.8582 48.375H46.9416C47.9191 48.375 48.7124 49.1777 48.7124 50.1667C48.7124 51.1557 47.9191 51.9583 46.9416 51.9583H39.8582C38.8807 51.9583 38.0874 51.1557 38.0874 50.1667C38.0874 49.1777 38.8807 48.375 39.8582 48.375Z",
                fill: "url(#paint17_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M39.3396 60.9167H47.4588C48.1512 60.9167 48.7126 61.4847 48.7126 62.1835C48.7126 62.884 48.1512 63.4502 47.4606 63.4502H39.3413C38.6489 63.4502 38.0894 62.8822 38.0894 62.1835C38.0876 61.4847 38.6489 60.9167 39.3396 60.9167Z",
                fill: "url(#paint18_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.2",
                d: "M39.8582 48.375H46.9416C47.9191 48.375 48.7124 49.1777 48.7124 50.1667C48.7124 51.1557 47.9191 51.9583 46.9416 51.9583H39.8582C38.8807 51.9583 38.0874 51.1557 38.0874 50.1667C38.0874 49.1777 38.8807 48.375 39.8582 48.375Z",
                fill: "url(#paint19_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.3",
                d: "M39.3396 60.9167H47.4588C48.1512 60.9167 48.7126 61.4847 48.7126 62.1835C48.7126 62.884 48.1512 63.4502 47.4606 63.4502H39.3413C38.6489 63.4502 38.0894 62.8822 38.0894 62.1835C38.0876 61.4847 38.6489 60.9167 39.3396 60.9167Z",
                fill: "url(#paint20_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.9",
                d: "M45.649 69.1584V69.1763C44.6396 69.1942 43.825 69.1942 43.4 69.1942C42.3729 69.1942 38.9375 69.1942 36.2458 68.8717C40.9386 66.1842 40.5844 63.443 40.5844 63.443C40.7969 63.1921 40.9386 62.9413 41.0271 62.7084C41.4521 61.6513 40.6375 60.9167 40.6375 60.9167C42.4261 58.8742 41.0802 51.9584 41.0802 51.9584C41.8027 50.9765 41.3937 49.1042 41.3937 49.1042H43.6834C42.4668 50.7759 43.4 51.9584 43.4 51.9584C42.0011 55.2371 43.524 60.9525 43.524 60.9525C42.975 61.5975 42.9042 62.2425 42.9927 62.7084C43.0459 63.1205 43.2229 63.4071 43.2229 63.4071C41.8594 67.0263 45.649 69.1584 45.649 69.1584Z",
                fill: "url(#paint21_linear_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M46.9417 60.9166H39.8583L39.8548 60.913C38.7834 59.288 38.7834 53.5887 39.8548 51.9636L39.8583 51.9583H46.9417L46.9452 51.9618C48.0166 53.5869 48.0166 59.2862 46.9452 60.9112L46.9417 60.9166Z",
                fill: "url(#paint22_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M62.8968 8.95825C62.8968 9.51367 62.8791 10.0691 62.8791 10.6066C62.8437 11.162 62.826 11.7174 62.7906 12.2549V12.2728C62.7551 13.0791 62.6843 13.8853 62.5958 14.6737C60.701 33.3787 50.0229 49.1095 45.1885 49.1095H41.6468C36.8833 49.1095 26.3999 33.737 24.3281 15.4083C24.1864 14.3512 24.0979 13.2941 24.0447 12.2012V12.1833C23.9739 11.1083 23.9385 10.0512 23.9385 8.95825C23.9385 8.40284 24.2041 7.88325 24.6645 7.41742C25.0541 7.02325 25.5676 6.66492 26.1874 6.36034C26.4885 6.19909 26.8249 6.05575 27.1791 5.8945C31.0218 4.35367 37.5916 3.58325 43.3999 3.58325C50.8729 3.58325 59.6031 4.85534 62.1531 7.41742C62.6312 7.86534 62.8968 8.38492 62.8968 8.95825Z",
                fill: "url(#paint23_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M60.0283 12.737V12.8624C59.9751 28.7724 48.571 41.1528 43.6835 41.1528H40.4074C35.5199 41.1528 24.098 28.7724 24.0449 12.8624V12.737C24.0449 10.802 31.0043 7.88159 43.4001 7.88159C45.5428 7.88159 47.8095 8.07868 49.9876 8.43701C50.023 8.43701 50.0585 8.45492 50.0939 8.45492C55.6543 9.79867 60.0283 10.802 60.0283 12.737Z",
                fill: "url(#paint24_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M60.0283 10.965V11.0905C59.9751 27.0005 48.571 39.3809 43.6835 39.3809H40.4074C35.5199 39.3809 24.098 27.0005 24.0449 11.0905V10.965C24.0449 9.03004 31.0043 6.10962 43.4001 6.10962C45.5428 6.10962 47.8095 6.3067 49.9876 6.66504C55.6012 8.00879 60.0283 9.01212 60.0283 10.965Z",
                fill: "url(#paint25_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M62.7908 12.2551C62.7553 13.0614 62.6845 13.8855 62.596 14.6739H60.0283C56.0439 14.638 48.872 14.6201 45.171 14.6201H41.6293C36.9366 14.6201 26.6303 15.3368 24.3283 15.4085C24.1866 14.3514 24.098 13.2943 24.0449 12.2014C25.196 9.89012 34.9533 7.90137 43.4001 7.90137C51.9001 7.90137 61.746 9.92595 62.7908 12.2551Z",
                fill: "url(#paint26_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M62.8792 8.95825C62.8792 9.60325 62.8615 11.9145 62.8438 12.5416C62.8721 11.5651 58.0661 7.91909 43.053 7.91909C30.1188 7.91909 23.9581 11.2785 24.0643 12.3391C24.0643 12.3391 23.9209 9.60325 23.9209 8.95825C23.9209 5.37492 34.5459 3.58325 43.4001 3.58325C52.2542 3.58325 62.8792 5.37492 62.8792 8.95825Z",
                fill: "url(#paint27_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.7",
                d: "M62.8791 8.95825V10.6066C62.8437 11.162 62.826 11.7174 62.7906 12.2549C61.7104 9.92575 51.5635 7.90117 43.3999 7.90117C35.3249 7.90117 25.2843 9.872 24.0447 12.1833C23.9739 11.1083 23.9385 10.0512 23.9385 8.95825C23.9385 8.40283 24.2041 7.88325 24.6645 7.41742C25.0541 7.02325 25.5676 6.66492 26.1874 6.36033C26.4885 6.19908 26.8249 6.05575 27.1791 5.8945C31.0218 4.35367 37.5916 3.58325 43.3999 3.58325C50.8728 3.58325 59.6031 4.85533 62.1531 7.41742C62.6135 7.88325 62.8791 8.40283 62.8791 8.95825Z",
                fill: "url(#paint28_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.6",
                d: "M43.4176 3.58325C34.5635 3.58325 23.9385 5.37492 23.9385 8.95825C23.9385 30.4583 36.3343 49.1041 41.6468 49.1041H45.1885C50.501 49.1041 62.8968 30.4583 62.8968 8.95825C62.8968 5.37492 52.2718 3.58325 43.4176 3.58325Z",
                fill: "url(#paint29_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                opacity: "0.2",
                d: "M43.4176 5.375C34.5635 5.375 23.9385 5.375 23.9385 8.95833C23.9385 30.4583 36.3343 49.1042 41.6468 49.1042H45.1885C50.501 49.1042 62.8968 30.4583 62.8968 8.95833C62.8968 5.375 52.2718 5.375 43.4176 5.375Z",
                fill: "url(#paint30_radial_1_3943)"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M68.2236 0.654175C68.3269 0.409834 68.6731 0.409834 68.7764 0.654176L69.789 3.05136C69.8194 3.12331 69.8767 3.18057 69.9486 3.21097L72.3458 4.22365C72.5902 4.32687 72.5902 4.67313 72.3458 4.77635L69.9486 5.78903C69.8767 5.81943 69.8194 5.87669 69.789 5.94864L68.7764 8.34582C68.6731 8.59017 68.3269 8.59017 68.2236 8.34582L67.211 5.94864C67.1806 5.87669 67.1233 5.81943 67.0514 5.78903L64.6542 4.77635C64.4098 4.67313 64.4098 4.32687 64.6542 4.22365L67.0514 3.21097C67.1233 3.18057 67.1806 3.12331 67.211 3.05136L68.2236 0.654175Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M8.72377 39.6542C8.82699 39.4098 9.17325 39.4098 9.27647 39.6542L10.7346 43.1059C10.765 43.1778 10.8223 43.2351 10.8942 43.2655L14.3459 44.7236C14.5903 44.8269 14.5903 45.1731 14.3459 45.2764L10.8942 46.7345C10.8223 46.7649 10.765 46.8222 10.7346 46.8941L9.27647 50.3458C9.17325 50.5902 8.82699 50.5902 8.72377 50.3458L7.26561 46.8941C7.23522 46.8222 7.17796 46.7649 7.10601 46.7345L3.6543 45.2764C3.40996 45.1731 3.40996 44.8269 3.6543 44.7236L7.10601 43.2655C7.17796 43.2351 7.23522 43.1778 7.26561 43.1059L8.72377 39.6542Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M72.7236 49.6542C72.8269 49.4098 73.1731 49.4098 73.2764 49.6542L74.1405 51.6999C74.1709 51.7718 74.2282 51.8291 74.3001 51.8595L76.3458 52.7236C76.5902 52.8269 76.5902 53.1731 76.3458 53.2764L74.3001 54.1405C74.2282 54.1709 74.1709 54.2282 74.1405 54.3001L73.2764 56.3458C73.1731 56.5902 72.8269 56.5902 72.7236 56.3458L71.8595 54.3001C71.8291 54.2282 71.7718 54.1709 71.6999 54.1405L69.6542 53.2764C69.4098 53.1731 69.4098 52.8269 69.6542 52.7236L71.6999 51.8595C71.7718 51.8291 71.8291 51.7718 71.8595 51.6999L72.7236 49.6542Z",
                fill: "#FEE485"
            }),
            /*#__PURE__*/ _jsxs("defs", {
                children: [
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint0_linear_1_3943",
                        x1: "43.3947",
                        y1: "79.9012",
                        x2: "43.3947",
                        y2: "57.4481",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.342",
                                stopColor: "#A44200"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint1_linear_1_3943",
                        x1: "43.2283",
                        y1: "63.7188",
                        x2: "43.7667",
                        y2: "89.488",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#983900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.549",
                                stopColor: "#812700"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.719",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint2_linear_1_3943",
                        x1: "43.3132",
                        y1: "72.1074",
                        x2: "44.0473",
                        y2: "60.9841",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.342",
                                stopColor: "#A44200"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint3_linear_1_3943",
                        x1: "43.2319",
                        y1: "68.7355",
                        x2: "43.8772",
                        y2: "99.5447",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#B65000"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.277",
                                stopColor: "#983900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.549",
                                stopColor: "#812700"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.719",
                                stopColor: "#782100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint4_linear_1_3943",
                        x1: "16.1186",
                        y1: "12.0399",
                        x2: "26.7076",
                        y2: "37.8019",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F2AC32"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#DE9104"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint5_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(22.9033 25.3122) rotate(68.0668) scale(14.0612 7.26789)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.875",
                                stopColor: "#E37900",
                                stopOpacity: "0.125"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint6_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(36.4302 32.5136) rotate(112.412) scale(14.064 9.78173)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint7_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(15.783 12.5793) rotate(43.0445) scale(5.29333 13.5374)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint8_linear_1_3943",
                        x1: "70.6815",
                        y1: "12.0399",
                        x2: "60.0925",
                        y2: "37.8019",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#F2AC32"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#DE9104"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint9_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(63.8968 25.3123) rotate(111.933) scale(14.0612 7.26789)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.875",
                                stopColor: "#E37900",
                                stopOpacity: "0.125"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint10_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(50.3706 32.5154) rotate(67.5878) scale(14.0622 9.78049)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#E37900"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#E37900",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint11_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(71.4332 12.1227) rotate(113.52) scale(4.04692 10.2592)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint12_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(42.3231 59.9672) rotate(90.47) scale(12.1246 10.3024)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.126",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.378",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.392",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.474",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.588",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint13_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(42.0789 58.9602) rotate(90.47) scale(13.5652 11.5264)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.126",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.378",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.392",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.474",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.588",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint14_linear_1_3943",
                        x1: "22.713",
                        y1: "66.5461",
                        x2: "53.393",
                        y2: "67.1902",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.153",
                                stopColor: "#F1B133"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.301",
                                stopColor: "#E19925"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.447",
                                stopColor: "#D7881B"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.557",
                                stopColor: "#D38218"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#BA6000"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint15_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(38.4111 68.0399) rotate(89.0203) scale(7.9052 21.0371)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.183",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.552",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.573",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.627",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.702",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint16_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(40.5742 66.5235) rotate(3.3641) scale(5.19575 4.24601)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint17_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(41.8021 49.8223) rotate(0.539104) scale(16.6767 4.76489)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.123",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.371",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.385",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.496",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.649",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint18_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(41.1732 62.4396) rotate(90.6644) scale(3.60987 41.719)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.08",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.242",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.251",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.383",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.565",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint19_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(42.3146 49.5506) rotate(92.7986) scale(4.9808 1.9662)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint20_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(41.9886 62.4022) rotate(2.37944) scale(4.25174 2.46194)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("linearGradient", {
                        id: "paint21_linear_1_3943",
                        x1: "40.9474",
                        y1: "175.517",
                        x2: "40.9474",
                        y2: "-1.76834",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint22_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(42.2397 57.2266) rotate(3.3641) scale(4.27312 9.63083)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.5"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint23_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(35.7265 20.5311) rotate(95.3031) scale(32.5865 28.3928)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FEDD30"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.264",
                                stopColor: "#FACB27"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.793",
                                stopColor: "#EF9B10"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.823",
                                stopColor: "#EE980F"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.886",
                                stopColor: "#DF8808"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.974",
                                stopColor: "#CE7500"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint24_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(39.0456 17.2804) rotate(81.9416) scale(21.6832 14.7392)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFDE6E"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFDE6C",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint25_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(36.5571 17.3068) rotate(82.4736) scale(11.3427 10.4754)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint26_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(43.6427 31.3958) rotate(0.0695638) scale(34.2178 23.2822)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.777",
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.91",
                                stopColor: "#CE7500",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#CE7500",
                                stopOpacity: "0.7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint27_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(34.3028 5.82409) rotate(-12.7581) scale(14.138 4.5357)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint28_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(55.1756 0.917879) rotate(37.8933) scale(13.1453 9.89057)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint29_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(37.0713 17.049) rotate(-91.6934) scale(57.2315 33.6879)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.323",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.491",
                                stopColor: "#D98107",
                                stopOpacity: "0.68"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.495",
                                stopColor: "#D98106",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.681",
                                stopColor: "#D58618",
                                stopOpacity: "0.02"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.686",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#D58619",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("radialGradient", {
                        id: "paint30_radial_1_3943",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(41.8572 16.5615) rotate(-91.0647) scale(66.349 32.3102)",
                        children: [
                            /*#__PURE__*/ _jsx("stop", {
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.173",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.25",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.391",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.043"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.495",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0.7"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.6",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.795",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "0.859",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ _jsx("stop", {
                                offset: "1",
                                stopColor: "#FFEEB3",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
export default Icon;
